import React from 'react';
import PropTypes from 'prop-types';
import { CheckBox } from '@onsolve/onsolve-ui-components';
import { injectIntl } from 'react-intl';
import { isCRC168Enabled } from 'featureFlags';

const CheckBoxBlock = ({
    showCheckBox,
    checkBoxChecked,
    checkBoxOnChange,
    checkBoxClass,
    checkBoxFillerClass,
    labelText,
    intl,
    labelLinkFormattedText,
}) => {
    const labelLinkText =
        typeof labelLinkFormattedText === 'string'
            ? labelLinkFormattedText
            : labelLinkFormattedText?.id
            ? intl.formatMessage(labelLinkFormattedText)
            : '';
    const ariaLabel = isCRC168Enabled()
        ? [labelText && intl.formatMessage(labelText), labelLinkText].filter(Boolean).join(' ')
        : labelText
        ? intl.formatMessage(labelText)
        : labelLinkText || undefined;

    return showCheckBox ? (
        <CheckBox
            checked={checkBoxChecked}
            onChange={checkBoxOnChange}
            className={checkBoxClass}
            aria-label={ariaLabel}
        />
    ) : (
        <div className={checkBoxFillerClass} />
    );
};

CheckBoxBlock.propTypes = {
    checkBoxChecked: PropTypes.bool,
    checkBoxClass: PropTypes.string,
    checkBoxFillerClass: PropTypes.string,
    checkBoxOnChange: PropTypes.func,
    intl: PropTypes.object,
    labelLinkFormattedText: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    labelText: PropTypes.object,
    showCheckBox: PropTypes.bool,
};

CheckBoxBlock.defaultProps = {
    showCheckBox: true,
    checkBoxClass: 'onsolve-sign-up__terms-and-conditions-checkbox',
    checkBoxFillerClass: 'onsolve-sign-up__terms-and-conditions-checkbox-space-filler',
    labelLinkFormattedText: '',
};

export default injectIntl(CheckBoxBlock);
